export function isIOSDevice(): boolean {
  const ua = navigator.userAgent;
  const isiPhoneOrIPad = /iPad|iPhone|iPod/.test(ua);
  const isModernIPad = ua.includes("Mac") && "ontouchend" in document;
  return isiPhoneOrIPad || isModernIPad;
}

export function isAndroidDevice(): boolean {
  return /Android/i.test(navigator.userAgent);
}

/**
 * True for machines that can never enter AR themselves (desktops, laptops), as
 * opposed to phones and tablets. Used to offer the QR hand-off instead of an
 * "unsupported" dead end.
 */
export function isDesktopDevice(): boolean {
  return !isIOSDevice() && !isAndroidDevice();
}

export function canTryAndroidSceneViewer(): boolean {
  const ua = navigator.userAgent;
  const chromeMatch = ua.match(/Chrome\/(\d+)/);
  const samsungMatch = ua.match(/SamsungBrowser\/(\d+)/);
  const chromeMajor = chromeMatch ? Number.parseInt(chromeMatch[1], 10) : 0;
  const samsungMajor = samsungMatch ? Number.parseInt(samsungMatch[1], 10) : 0;
  const isWebView = /; wv\)/.test(ua) || /Version\/\d+\.\d+/.test(ua);

  return (
    isAndroidDevice() && !isWebView && (chromeMajor >= 81 || samsungMajor >= 10)
  );
}

export function openQuickLookFromUSDZBlob(
  blob: Blob,
  options: { arPlacement?: "floor" | "wall" } = {},
): string | null {
  try {
    const href = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    const image = document.createElement("img");

    anchor.href = href;
    anchor.rel = "ar";
    if (options.arPlacement) {
      anchor.setAttribute("ar-placement", options.arPlacement);
    }

    image.alt = "";
    anchor.appendChild(image);
    anchor.style.position = "fixed";
    anchor.style.left = "-1px";
    anchor.style.top = "-1px";
    anchor.style.width = "1px";
    anchor.style.height = "1px";
    anchor.style.opacity = "0";
    anchor.style.pointerEvents = "none";

    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    return href;
  } catch {
    return null;
  }
}

export function openAndroidSceneViewer(modelUrl: string): boolean {
  try {
    if (modelUrl.startsWith("blob:") || modelUrl.startsWith("data:")) {
      return false;
    }

    const absoluteModelUrl = new URL(modelUrl, window.location.href);
    absoluteModelUrl.hash = "";

    const pageUrl = new URL(window.location.href);
    const params = new URLSearchParams({
      file: absoluteModelUrl.toString(),
      mode: "ar_preferred",
      disable_occlusion: "true",
    });

    const intent = `intent://arvr.google.com/scene-viewer/1.2?${params.toString()}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(pageUrl.toString())};end;`;
    const anchor = document.createElement("a");

    anchor.href = intent;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    return true;
  } catch {
    return false;
  }
}
